import { Injectable } from "@angular/core";
import { MetaModel } from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
import { MentoringDocFormDataService } from "common/services/data-services/student/mentoring-doc/mentoring-form-data.service";
import { MentoringDocumentModel } from "common/models/page-models/mentoring-document/mentoring-document-data.model";
import { MentoringDocumentMetaModel } from "common/models/page-models/mentoring-document/mentoring-document-form-meta.model";



@Injectable({
    providedIn: 'root'
})
export class MentoringFormWidgetService extends FormWidgetService<MentoringDocumentModel> {
    constructor(protected ds: MentoringDocFormDataService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new MentoringDocumentMetaModel();
        return meta.getMetaModel();
    }
}
